import { render } from "./ViewResetPassword.vue?vue&type=template&id=7bebcd36&ts=true"
import script from "./ViewResetPassword.vue?vue&type=script&lang=ts"
export * from "./ViewResetPassword.vue?vue&type=script&lang=ts"

import "./ViewResetPassword.vue?vue&type=style&index=0&id=7bebcd36&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__